import { useEffect, useState } from 'react';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import getConfiguratorData from '@/api/get/configuratorData';

const useProductData = () => {
  const [{ productsData }, { setProductsData }] = useConfiguratorContext();
  const [fetchingProductsData, setFetchingProductsData] = useState(false);

  const successCB = data => {
    setProductsData(data);
  };

  useEffect(() => {
    if (productsData.length === 0 && !fetchingProductsData) {
      setFetchingProductsData(true);
      getConfiguratorData({
        successCB,
      });
    }
  }, [setProductsData, fetchingProductsData]);
};

export default useProductData;
